var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSemaforo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 244.06 579.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #334a5f;\n      }\n\n      .cls-2 {\n        fill: #4ddac3;\n      }\n\n      .cls-3 {\n        fill: #62edd2;\n      }\n\n      .cls-4 {\n        fill: #ff8983;\n      }\n\n      .cls-5 {\n        fill: #fff799;\n      }\n\n      .cls-6 {\n        fill: #41596b;\n      }\n\n      .cls-7 {\n        fill: #ff735b;\n      }\n\n      .cls-8 {\n        fill: #4d697c;\n      }\n\n      .cls-9 {\n        fill: #efe854;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 108.99,
    y: 449.46,
    width: 19.27,
    height: 129.57
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M191.3,322.1v121.7c0,3.12-2.54,5.65-5.66,5.65H58.41c-3.12,0-5.65-2.53-5.65-5.65v-121.7h138.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M191.3,305.27v16.83H52.76v-16.83c0-3.12,2.53-5.65,5.65-5.65h127.23c3.12,0,5.66,2.53,5.66,5.65Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.32,315.2c0,3.75-3.04,6.78-6.78,6.78s-6.78-3.04-6.78-6.78,3.04-6.78,6.78-6.78,6.78,3.04,6.78,6.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M181.3,315.2c0,3.75-3.04,6.78-6.78,6.78s-6.78-3.04-6.78-6.78,3.04-6.78,6.78-6.78,6.78,3.04,6.78,6.78Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.32,433.75c0,3.75-3.04,6.78-6.78,6.78s-6.78-3.04-6.78-6.78,3.04-6.78,6.78-6.78,6.78,3.04,6.78,6.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.3,433.75c0,3.75-3.04,6.78-6.78,6.78s-6.78-3.04-6.78-6.78,3.04-6.78,6.78-6.78,6.78,3.04,6.78,6.78Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.76,321.98H5.69c-4.34,0-7.08,4.68-4.96,8.46l30.75,54.78c4.32,7.69,12.45,12.45,21.27,12.45h0v-75.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.3,321.98h47.07c4.34,0,7.08,4.68,4.96,8.46l-30.75,54.78c-4.32,7.69-12.45,12.45-21.27,12.45h0v-75.7Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 122.03,
    cy: 374.47,
    r: 52.49,
    transform: "translate(-270.62 405.31) rotate(-76.44)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167.71,374.57c0,25.24-20.46,45.71-45.71,45.71s-45.71-20.46-45.71-45.71c0-7.69,1.9-14.92,5.25-21.29,7.66,14.51,22.9,24.41,40.46,24.41s32.79-9.9,40.46-24.41c3.35,6.36,5.25,13.6,5.25,21.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162.46,353.28c-7.66,14.51-22.9,24.41-40.46,24.41s-32.79-9.9-40.46-24.41c7.65-14.52,22.9-24.42,40.46-24.42s32.8,9.9,40.46,24.42Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M191.3,172.33v121.7c0,3.12-2.54,5.65-5.66,5.65H58.41c-3.12,0-5.65-2.53-5.65-5.65v-121.7h138.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.3,155.49v16.83H52.76v-16.83c0-3.12,2.53-5.65,5.65-5.65h127.23c3.12,0,5.66,2.53,5.66,5.65Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.33,165.48c0,3.75-3.04,6.78-6.78,6.78s-6.78-3.04-6.78-6.78,3.04-6.78,6.78-6.78,6.78,3.04,6.78,6.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M181.3,165.48c0,3.75-3.04,6.78-6.78,6.78s-6.78-3.04-6.78-6.78,3.04-6.78,6.78-6.78,6.78,3.04,6.78,6.78Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.33,284.03c0,3.75-3.04,6.78-6.78,6.78s-6.78-3.04-6.78-6.78,3.04-6.78,6.78-6.78,6.78,3.04,6.78,6.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.3,284.03c0,3.75-3.04,6.78-6.78,6.78s-6.78-3.04-6.78-6.78,3.04-6.78,6.78-6.78,6.78,3.04,6.78,6.78Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.76,172.27H5.69c-4.34,0-7.08,4.68-4.96,8.46l30.75,54.78c4.32,7.69,12.45,12.45,21.27,12.45h0v-75.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.3,172.27h47.07c4.34,0,7.08,4.68,4.96,8.46l-30.75,54.78c-4.32,7.69-12.45,12.45-21.27,12.45h0v-75.7Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M191.3,22.49v121.7c0,3.12-2.54,5.65-5.66,5.65H58.41c-3.12,0-5.65-2.53-5.65-5.65V22.49h138.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.3,5.65v16.83H52.76V5.65c0-3.12,2.53-5.65,5.65-5.65h127.23c3.12,0,5.66,2.53,5.66,5.65Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.33,15.58c0,3.75-3.04,6.78-6.78,6.78s-6.78-3.04-6.78-6.78,3.04-6.78,6.78-6.78,6.78,3.04,6.78,6.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M181.3,15.58c0,3.75-3.04,6.78-6.78,6.78s-6.78-3.04-6.78-6.78,3.04-6.78,6.78-6.78,6.78,3.04,6.78,6.78Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.33,134.13c0,3.75-3.04,6.78-6.78,6.78s-6.78-3.04-6.78-6.78,3.04-6.78,6.78-6.78,6.78,3.04,6.78,6.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.3,134.13c0,3.75-3.04,6.78-6.78,6.78s-6.78-3.04-6.78-6.78,3.04-6.78,6.78-6.78,6.78,3.04,6.78,6.78Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.76,22.49H5.69c-4.34,0-7.08,4.68-4.96,8.46l30.75,54.78c4.32,7.69,12.45,12.45,21.27,12.45h0V22.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.3,22.49h47.07c4.34,0,7.08,4.68,4.96,8.46l-30.75,54.78c-4.32,7.69-12.45,12.45-21.27,12.45h0V22.49Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 122.03,
    cy: 74.85,
    r: 52.49,
    transform: "translate(-17.19 108.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M167.74,74.85c0,25.24-20.46,45.71-45.71,45.71s-45.71-20.46-45.71-45.71c0-7.69,1.9-14.92,5.25-21.29,7.66,14.51,22.9,24.41,40.46,24.41s32.79-9.9,40.46-24.41c3.35,6.36,5.25,13.6,5.25,21.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162.49,53.57c-7.66,14.51-22.9,24.41-40.46,24.41s-32.79-9.9-40.46-24.41c7.65-14.52,22.9-24.42,40.46-24.42s32.8,9.9,40.46,24.42Z"
  })))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 122.03,
    cy: 231.37,
    r: 52.49,
    transform: "translate(-131.5 295.76) rotate(-76.44)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M167.72,231.47c0,25.24-20.46,45.71-45.71,45.71s-45.71-20.46-45.71-45.71c0-7.69,1.9-14.92,5.25-21.29,7.66,14.51,22.9,24.41,40.46,24.41s32.79-9.9,40.46-24.41c3.35,6.36,5.25,13.6,5.25,21.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M162.47,210.18c-7.66,14.51-22.9,24.41-40.46,24.41s-32.79-9.9-40.46-24.41c7.65-14.52,22.9-24.42,40.46-24.42s32.8,9.9,40.46,24.42Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemaforo);
export default __webpack_public_path__ + "static/media/semaforo.173bf908484767aafd949c13a6ab530b.svg";
export { ForwardRef as ReactComponent };